import { Button, Modal, InputSelect, RadioGroup } from '@teo/components';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import {
  ArrowRight,
  ArrowDown,
  ArrowLeft,
  ArrowUp,
} from '@teo/components/icons';
import { format } from 'date-fns';
import { useState } from 'react';
import { axios } from '@/axios';
import { config } from '@/config';
import { newUid } from '@/util.js';

const MergeModal = ({
  closeModal,
  setIsOpenMergeModal,
  setMergeCourse,
  course,
  mergeContent,
  setResetCourseTable,
  userId,
}: any) => {
  const { t } = useTranslation();

  //   console.log(course);
  //   console.log('mergeContent', mergeContent);
  const [selectedContent, setSelectedContent] = useState<any>(null);
  const [isChecked, setIsChecked] = useState('active');

  const isMobile = useMediaQuery({
    query: '(max-width: 1279px)',
  });

  const handleMerge = async () => {
    await axios.post(
      `${config.teodoc}/api/movecourse/${userId}/${
        isChecked === 'active' ? selectedContent?.value : course?.courseId
      }/${isChecked === 'active' ? course?.courseId : selectedContent?.value}`
    );
    setResetCourseTable(newUid(20));
    setMergeCourse(null);
    setIsOpenMergeModal(false);
  };

  return (
    <div className="bg-white">
      <div className="fixed inset-0 z-[100] flex rounded-xl bg-white/75 px-3">
        <div className="mx-auto my-8 h-max w-full max-w-[800px]  rounded-xl bg-white drop-shadow-m">
          <Modal.Header onClose={closeModal}>
            <h2 className="text-sm font-semibold">
              {t('merge_modal.heading')}
            </h2>
          </Modal.Header>

          <Modal.Body>
            <div className="flex flex-col gap-6">
              {isMobile ? (
                <RadioGroup
                  label={''}
                  onChange={(value: string) => {
                    setIsChecked(value);
                  }}
                  value={isChecked}
                >
                  <div className="flex flex-col items-center">
                    <div className="flex w-full flex-col items-center">
                      <h4 className="mb-4 text-base text-grey-08">
                        {t('merge_modal.current_course')}
                      </h4>
                      <div className="flex flex-col items-center">
                        <div className="w-16 min-w-16 rounded-md sm:w-20 sm:min-w-20">
                          <img
                            src={
                              course?.courseImage ||
                              course?.image ||
                              '/images/courseFallback.png'
                            }
                            alt={course.name}
                            className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                          />
                        </div>
                        <div className="my-4 flex flex-col items-center">
                          <p className="text-sm font-medium">
                            {course?.courseName || course?.name}
                          </p>
                          <span className="text-xs text-grey-06">
                            {format(new Date(course?.updatedAt), 'dd/MM/yyyy')}
                          </span>
                        </div>
                      </div>
                      <div className="flex">
                        <RadioGroup.Option value="active">
                          <p className="text-sm">
                            {t('merge_modal.main_course')}
                          </p>
                        </RadioGroup.Option>
                      </div>
                    </div>
                    <div className="my-4">
                      {isChecked === 'active' ? (
                        <ArrowUp className="w-5 text-grey-06" />
                      ) : (
                        <ArrowDown className="w-5 text-grey-06" />
                      )}
                    </div>
                    <div className="flex w-full flex-col items-center">
                      <h4 className="mb-4 text-base text-grey-08">
                        {t('merge_modal.merge_with')}
                      </h4>
                      <div className="mb-4 w-full max-w-[300px]">
                        <InputSelect
                          onChange={(selectCrs) => {
                            setSelectedContent(selectCrs);
                          }}
                          value={selectedContent}
                          options={mergeContent?.map((crs: any) => ({
                            value: crs?.courseId,
                            name: crs?.courseName || crs?.name,
                            updatedAt: crs?.updatedAt,
                          }))}
                        >
                          {(options) => <span>{options?.name}</span>}
                        </InputSelect>
                      </div>
                      <div className="flex flex-col items-center">
                        <div className="h-12 w-16 min-w-16 rounded-md rounded-md bg-[#1E1E2014] sm:h-14 sm:w-20 sm:min-w-20">
                          {selectedContent && (
                            <img
                              src={
                                course?.courseImage ||
                                course?.image ||
                                '/images/courseFallback.png'
                              }
                              alt={course.name}
                              className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                            />
                          )}
                        </div>
                        {selectedContent ? (
                          <div className="my-4 flex flex-col items-center">
                            <p className="text-sm font-medium">
                              {selectedContent?.courseName ||
                                selectedContent?.name}
                            </p>
                            <span className="text-xs text-grey-06">
                              {format(
                                new Date(selectedContent?.updatedAt),
                                'dd/MM/yyyy'
                              )}
                            </span>
                          </div>
                        ) : (
                          <p className="my-4 text-sm text-grey-06">
                            {t('merge_modal.select_course')}
                          </p>
                        )}
                      </div>
                      <div
                        className={`flex  flex-col ${
                          course?.learningpathId &&
                          'pointer-events-none opacity-50'
                        }`}
                      >
                        <RadioGroup.Option value="selected">
                          <p className="text-sm">
                            {t('merge_modal.main_course')}
                          </p>
                        </RadioGroup.Option>
                      </div>
                    </div>
                  </div>
                </RadioGroup>
              ) : (
                <div className="flex flex-col">
                  <div className="mb-6 flex">
                    <div className="flex max-w-[45%] flex-[1_0_45%]">
                      <h4 className="mb-4 text-base text-grey-08">
                        {t('merge_modal.current_course')}
                      </h4>
                    </div>
                    <div className="ml-auto flex max-w-[45%] flex-[1_0_45%] flex-col">
                      <h4 className="mb-4 text-base text-grey-08">
                        {t('merge_modal.merge_with')}
                      </h4>
                      <div className="w-full">
                        <InputSelect
                          onChange={(selectCrs) => {
                            setSelectedContent(selectCrs);
                          }}
                          value={selectedContent}
                          options={mergeContent?.map((crs: any) => ({
                            value: crs?.courseId,
                            name: crs?.courseName || crs?.name,
                            updatedAt: crs?.updatedAt,
                          }))}
                        >
                          {(options) => <span>{options?.name}</span>}
                        </InputSelect>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="flex  flex-[1_0_45%] items-center">
                      <div className="mr-3 w-16 min-w-16 rounded-md sm:w-20 sm:min-w-20">
                        <img
                          src={
                            course?.courseImage ||
                            course?.image ||
                            '/images/courseFallback.png'
                          }
                          alt={course.name}
                          className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                        />
                      </div>
                      <div className="flex flex-col">
                        <p className="text-sm font-medium">
                          {course?.courseName || course?.name}
                        </p>
                        <span className="text-xs text-grey-06">
                          {format(new Date(course?.updatedAt), 'dd/MM/yyyy')}
                        </span>
                      </div>
                    </div>
                    {isMobile ? (
                      <div className="my-4">
                        {isChecked === 'active' ? (
                          <ArrowUp className="w-5 text-grey-06" />
                        ) : (
                          <ArrowDown className="w-5 text-grey-06" />
                        )}
                      </div>
                    ) : (
                      <div className="mx-6">
                        {isChecked === 'active' ? (
                          <ArrowLeft className="w-6 text-grey-06" />
                        ) : (
                          <ArrowRight className="w-6 text-grey-06" />
                        )}
                      </div>
                    )}
                    <div className="flex flex-[1_0_45%] items-center">
                      <div className="mr-3 h-12 w-16 min-w-16 rounded-md rounded-md bg-[#1E1E2014] sm:h-14 sm:w-20 sm:min-w-20">
                        {selectedContent && (
                          <img
                            src={
                              course?.courseImage ||
                              course?.image ||
                              '/images/courseFallback.png'
                            }
                            alt={course.name}
                            className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                          />
                        )}
                      </div>
                      {selectedContent ? (
                        <div className="flex flex-col">
                          <p className="text-sm font-medium">
                            {selectedContent?.courseName ||
                              selectedContent?.name}
                          </p>
                          <span className="text-xs text-grey-06">
                            {format(
                              new Date(selectedContent?.updatedAt),
                              'dd/MM/yyyy'
                            )}
                          </span>
                        </div>
                      ) : (
                        <p className="text-sm text-grey-06">
                          {t('merge_modal.select_course')}
                        </p>
                      )}
                    </div>
                  </div>
                  <RadioGroup
                    label={''}
                    onChange={(value: string) => {
                      setIsChecked(value);
                    }}
                    value={isChecked}
                  >
                    <div className="mt-2 flex items-center">
                      <div className="flex max-w-[45%] flex-[1_0_45%]">
                        <RadioGroup.Option value="active">
                          <p className="text-sm">
                            {t('merge_modal.main_course')}
                          </p>
                        </RadioGroup.Option>
                      </div>
                      <div
                        className={`ml-auto flex max-w-[45%] flex-[1_0_45%] flex-col ${
                          course?.learningpathId &&
                          'pointer-events-none opacity-50'
                        }`}
                      >
                        <RadioGroup.Option value="selected">
                          <p className="text-sm">
                            {t('merge_modal.main_course')}
                          </p>
                        </RadioGroup.Option>
                      </div>
                    </div>
                  </RadioGroup>
                </div>
              )}
              <div className="-ml-6 -mr-6 flex justify-between border-t px-6 pt-6">
                <Button
                  variant="ghost"
                  onClick={() => setIsOpenMergeModal(false)}
                >
                  {t('button.cancel')}
                </Button>
                <Button
                  disabled={!selectedContent}
                  onClick={() => handleMerge()}
                >
                  {t('merge_modal.merge')}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </div>
      </div>
    </div>
  );
};

export default MergeModal;
